import { api } from '@/lib/api';
import { SaveTemplateDto } from '@/lib/ServerApi';
import { capitalize } from '@/utils/capitalize';
import { CustomCellRendererProps } from '@ag-grid-community/react';
import { Flex, Textarea, Button, Box } from '@chakra-ui/react';
import { useMutation } from '@tanstack/react-query';
import { useState } from 'react';
import { useRevalidator } from 'react-router-dom';

export const TemplatesDescriptionRenderer = ({ value, data: rowData }: CustomCellRendererProps) => {
    const [editing, setEditing] = useState(false);
    const [newValue, setNewValue] = useState(value);
    const { revalidate } = useRevalidator();

    const { mutate: saveTemplate } = useMutation<unknown, unknown, SaveTemplateDto>({
        mutationFn: async (body) => {
            return api.template.save(body);
        },
        onSettled: () => {
            revalidate();
        },
    });

    return !editing ? (
        <Box onDoubleClick={() => setEditing(true)} lineHeight="20px" py="2">
            {capitalize(value)}
        </Box>
    ) : (
        <Flex flexDir="column" gap="1" lineHeight={0} py="2">
            <Textarea height={40} value={newValue} onChange={(e) => setNewValue(e.target.value)} />
            <Flex justifyContent="end" gap="2">
                <Button
                    type="button"
                    size="xs"
                    onClick={() => {
                        saveTemplate({
                            ...rowData,
                            description: newValue,
                        });
                        setEditing(false);
                    }}>
                    Save
                </Button>
                <Button type="button" variant="outline" size="xs" onClick={() => setEditing(false)}>
                    Cancel
                </Button>
            </Flex>
        </Flex>
    );
};
